<template>
  <div style="display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 511 511"
    >
      <path
        :fill="iconColor"
        d="M502.5,199.3c-12.5-8.7-25.9-15.8-39.8-21.3c20.5-18.6,33.4-45.5,33.4-75.3C496,46.7,450.4,1,394.2,1
        c-56.1,0-101.8,45.7-101.8,101.8c0,29.7,12.8,56.5,33.1,75.1c-2.8,1.1-5.6,2.2-8.3,3.4c-12.5,5.5-24.2,12.3-35.1,20.2
        c-15.1-37.4-51.7-63.9-94.5-63.9c-56.1,0-101.8,45.7-101.8,101.8c0,29.6,12.7,56.3,33,74.9c-54.1,20.3-98,63.9-115.9,119.4
        c-5.9,18.4-2.8,38,8.6,53.6c11.4,15.6,29,24.6,48.4,24.6h173.6c11,0,20-8.9,20-20c0-11-8.9-19.9-20-19.9H59.9
        c-6.5,0-12.3-3-16.1-8.2c-3.8-5.2-4.8-11.7-2.9-17.9c19.7-61.3,79.9-104.2,146.3-104.2c30.9,0,60.6,9.3,85.8,26.9
        c9,6.3,21.5,4.1,27.8-5c6.3-9,4.1-21.5-5-27.8c-12.5-8.7-25.9-15.8-39.8-21.3c18.6-16.9,30.9-40.5,33-67
        c28.2-27.5,65.1-42.5,104.7-42.5c30.9,0,60.6,9.3,85.8,26.9c9,6.3,21.5,4.1,27.8-5C513.7,218.1,511.5,205.7,502.5,199.3z
        M187.7,301.3c-34.1,0-61.9-27.8-61.9-61.9c0-34.1,27.8-61.9,61.9-61.9c34.1,0,61.9,27.8,61.9,61.9
        C249.5,273.5,221.8,301.3,187.7,301.3z M394.2,164.7c-34.1,0-61.9-27.8-61.9-61.9c0-34.1,27.8-61.9,61.9-61.9
        c34.1,0,61.9,27.8,61.9,61.9C456.1,136.9,428.4,164.7,394.2,164.7z"
      />
      <path
        :fill="iconColor"
        d="M511,417.1c0,11-8.9,20-20,20h-54.9V492c0,11-8.9,20-20,20c-11,0-20-8.9-20-20v-54.9h-54.9c-11,0-20-8.9-20-20
        c0-11,8.9-20,20-20h54.9v-54.9c0-11,8.9-20,20-20c11,0,20,8.9,20,20v54.9H491C502.1,397.2,511,406.1,511,417.1z"
      />
    </svg>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";

export default {
  name: "InviteIcon",
  mixins: [globals],
  props: {
    size: {
      type: [String, Number],
      default: 30
    },
    color: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },
    shadowBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null;
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    iconColor() {
      const baseColor = this.color || this.isDescriptionColour || this.bgTheme || '#585957';
      const background = this.bgColor || this.shadowBgColor;

      if (this.isDarkTheme && background && this.areColorsSimilar(baseColor, background)) {
        return this.lightenColor(baseColor, 40);
      }
      return baseColor;
    }
  },
  methods: {
    hexToRgb(hex) {
      if (!hex) return null;
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return { r, g, b };
    },
    areColorsSimilar(color1, color2, threshold = 60) {
      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);
      if (!rgb1 || !rgb2) return false;

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );
      return distance < threshold;
    },
    lightenColor(hex, percent) {
      const rgb = this.hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * (percent / 100)));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * (percent / 100)));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * (percent / 100)));

      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
    }
  }
};
</script>
